// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bfN8C8WTY8IBx2oyHCrz .EMt1Iav13iUe3KCTkUk5{height:44px;font-size:14px;font-weight:500}.bfN8C8WTY8IBx2oyHCrz .EMt1Iav13iUe3KCTkUk5.CAxoq7zwgcaU165dFeDM{margin-top:40px}.bfN8C8WTY8IBx2oyHCrz .vDdRWJaA9hEZ7TpbZcGO{margin-bottom:24px}.bfN8C8WTY8IBx2oyHCrz .SM3P0F6HOnMeUtbed6RB{text-align:center;color:var(--content-primary-tertiary);padding-top:12px}.bfN8C8WTY8IBx2oyHCrz .jmHSdcTiKQgVDqTotqas{margin:32px 0}.bfN8C8WTY8IBx2oyHCrz .zISWXCs5hwXgPNMsfLn7{padding:12px;font-size:14px;font-weight:400;line-height:20px}.bfN8C8WTY8IBx2oyHCrz .zISWXCs5hwXgPNMsfLn7.vDdRWJaA9hEZ7TpbZcGO{margin-bottom:4px}.bfN8C8WTY8IBx2oyHCrz .ByMoMX2Z1MAz4nVzbPHi{margin-top:20px;margin-bottom:4px}.bfN8C8WTY8IBx2oyHCrz .x8qmducinns8sOmbemSc{justify-content:center;align-items:center;margin-top:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `bfN8C8WTY8IBx2oyHCrz`,
	"button": `EMt1Iav13iUe3KCTkUk5`,
	"signUp": `CAxoq7zwgcaU165dFeDM`,
	"error": `vDdRWJaA9hEZ7TpbZcGO`,
	"termsAndPolicy": `SM3P0F6HOnMeUtbed6RB`,
	"divider": `jmHSdcTiKQgVDqTotqas`,
	"textField": `zISWXCs5hwXgPNMsfLn7`,
	"inputLabel": `ByMoMX2Z1MAz4nVzbPHi`,
	"bottom": `x8qmducinns8sOmbemSc`
};
export default ___CSS_LOADER_EXPORT___;
